declare module 'vue/types/vue' {
    interface Vue {
        $api: any,
        $subscriptions: any[],
        $eventManager;
        $eventEmitter;
        cart: any;
        appName:any;
    }
}

import './assets/styles/main.scss';

import Vue from 'vue'
import Selector from './components/selector.vue'
import moment from "moment";
import EventManager from "@/plugins/event-manager";
import Api from './plugins/api';
import Cart from './components/cart.vue';
import ThankYou from './components/thank-you.vue';
import Checkout from './components/checkout.vue';
import ErrorComp from './components/error.vue';
import Store from "./store/index";
import i18n from '@/plugins/i18n';
import Vuex from 'vuex';
import {
    appendDiv,
    deleteCookie,
    getCookie,
    mount,
    openCheckout,
    parseUrl,
    setCookie,
    toDecimal
} from "@/utilities/utilities";
import EventEmitter from "@/plugins/event-emitter";

Vue.use(Vuex);

const store = new Vuex.Store(Store);

window['i18n'] = i18n;

Vue.config.productionTip = false;

moment.locale((document.documentElement.lang || 'en-EN').slice(0, 2));

Vue.filter('date', function (value, format) {
    if (value) {
        return moment(value).format(format)
    }
});

Vue.filter('decimal', function (value) {
    return toDecimal(value);
});

Vue.mixin({
    beforeMount: function () {
        if (!this.$subscriptions) this.$subscriptions = [];

        if (this.decorators && this.decorators.Listen) {
            this.$subscriptions.push(...this.decorators.Listen.map(key => this[key]('mixin')));
        }
    },
    destroyed: function () {
        this.$subscriptions.forEach(sub => sub());
    }
});



Vue.use({
    install: (Vue) => {
        Vue.prototype.$api = Api;
        Vue.prototype.$eventManager = EventManager;
        Vue.prototype.$store = store;
        Vue.prototype.$eventEmitter = EventEmitter;
    }
});


let search = parseUrl(window.location.search);


store.dispatch('setReservationId', search['reservationId'] || getCookie('reservationId'));
store.commit('set', {key: 'search', value: search || {}});

let checkoutDiv = document.querySelector('#L2Tcheckout');

if(checkoutDiv) {
    mount(Checkout, '#L2Tcheckout');
}

if (search['thank-you']) {
    appendDiv('thank-you');

    if(search['resultCode'] !== 'authorised') {
        startUp();
        openCheckout();
    } else {
        mount(ThankYou, '.thank-you');
    }
} else {
    startUp();
}


export function startUpSelector(eventId?, date = moment(), body = {}):any {
    let format = date.format('YYYY-M-DDTHH:mm:ss'),
        reservationId = store.state.reservationId;


    if (reservationId && reservationId !== 'null') {
        body['Reservation_id'] = reservationId;
    }

    return Promise.all([
        Api.get('getselector', Object.assign({}, body, {Event_id: eventId})),
        Api.get('dateavailability', {
            From_date_time: moment().format('YYYY-M-DDTHH:mm:ss'),
            Event_id: eventId,
            To_date_time: moment().add(3, 'years').format('YYYY-M-DDTHH:mm:ss')
        }),
        Api.get('availability', {
            From_date_time: format,
            Event_id: eventId,
            To_date_time: format
        }),
        Api.get('typeavailability', {
            From_date_time: format,
            To_date_time: format,
            eventId: eventId
        })
    ].map(promise => promise.catch(e => new Object())));
}

async function startUp() {
    let [selectorResponse, dateAvailabilityResponse, slotAvailabilityResponse, typeAvailabilityResponse] = await startUpSelector().catch(console.log);

    createStyle(selectorResponse.Primary_color, selectorResponse.Secondary_color, selectorResponse.Text_color);

    store.commit('set', {key: 'ticketTypesList', value: selectorResponse.TicketTypeList});
    store.commit('set', {key: 'dateAvailability', value: dateAvailabilityResponse.Dates});
    store.commit('set', {key: 'slotAvailability', value: slotAvailabilityResponse});
    store.commit('set', {key: 'typeAvailability', value: typeAvailabilityResponse});
    store.dispatch('setCart', selectorResponse.Cart);
    store.commit('set', {key: 'selector', value: selectorResponse});

    // Empty target div
    const div = document.querySelector('#L2Tticketselector');
    [].slice.call(div.children).forEach(child => div.removeChild(child))

    mount(Selector, '#L2Tticketselector');

    if(selectorResponse.has_Cart) {
        mount(Cart, '#L2Tcart');
    }
}



function createStyle(primaryColor, secondaryColor, textColor) {
    let head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = '';

    head.appendChild(style);


    let colors = [
        {
            prefix: 'primary',
            hex: `#${primaryColor}`
        },
        {
            prefix: 'secondary',
            hex: `#${secondaryColor}`
        }
    ];

    colors.forEach(color => {
        css += `.l2t .bg-color-${color.prefix} {background-color: ${color.hex}!important;}`;
        css += `.l2t .color-${color.prefix} {color: ${color.hex}!important;}`;
        css += `.l2t .border-color-${color.prefix} {border-color: ${color.hex}!important;}`;
    });


    css += `.l2t .text-color {color: #${textColor}!important`;


    style.appendChild(document.createTextNode(css));
}
